import { useMemo } from 'react';
import { RootState } from 'store';
import { ListItem } from 'common/types/common';

import { useSelector } from 'react-redux';

import { STATE } from '../types/state';

export const useRoadsideService = () => {
  const roadsideService = useSelector((state: RootState) => (
    state[STATE].roadsideService
  ));

  return roadsideService;
};

export const useRoadsideServiceList = () => {
  const roadsideService = useRoadsideService();

  const roadsideServiceList = useMemo(() => (
    roadsideService.map(({ code, name }) => ({ key: code, value: name }))
  ), [roadsideService]);

  return roadsideServiceList;
};

export const useRoadsideServiceListFilteredByCodes = (roadsideServiceCodes: string[]) => {
  const roadsideServiceList = useRoadsideServiceList();

  const roadsideServiceListFilteredByCodes = useMemo(() => (
    roadsideServiceList.reduce((acc, item) => {
      if (roadsideServiceCodes.find(roadsideServiceCode => roadsideServiceCode.toString() === item.key.toString())) {
        acc.push(item);
      }
      return acc;
    }, [] as ListItem[])
  ), [
    roadsideServiceList,
    roadsideServiceCodes
  ]);

  return roadsideServiceListFilteredByCodes;
};
